<div class="timesheet-row">
    <div class="timesheet-row__activity">
        @if (marker() === 'sow') {
            <span class="fw-semibold" translate="TIMESHEET_START_OF_WORK_LABEL"></span>
        } @else {
            <span class="fw-semibold" translate="TIMESHEET_END_OF_WORK_LABEL"></span>
        }
    </div>

    <div class="timesheet-row__times">
        <pace-instant-field
            [formField]="instant()"
            [minInstant]="minInstant()"
            [maxInstant]="maxInstant()"
            [dateAriaLabel]="
                (marker() === 'sow'
                    ? 'TIMESHEET_START_OF_WORK_TABLE_START_DATE_LABEL'
                    : 'TIMESHEET_END_OF_WORK_TABLE_END_DATE_LABEL'
                ) | translate
            "
            [timeAriaLabel]="
                (marker() === 'sow'
                    ? 'TIMESHEET_START_OF_WORK_TABLE_START_TIME_LABEL'
                    : 'TIMESHEET_END_OF_WORK_TABLE_END_TIME_LABEL'
                ) | translate
            "
        ></pace-instant-field>
    </div>

    <div class="timesheet-row__duration text-end text-lg-start">
        @if (marker() === 'eow' && canCollapseGap()) {
            <button
                class="btn btn-sm btn-secondary"
                type="button"
                (click)="collapseGap.emit()"
                [attr.aria-label]="'TIMESHEET_REMOVE_END_OF_WORK_GAP_LABEL' | translate"
            >
                <fa-icon [icon]="faPause" [rotate]="90"></fa-icon>
            </button>
        }
    </div>
</div>
